import { APPLICATION_ROUTES } from 'constants/routes';
import { IconCalendarEvent } from '@tabler/icons';
import { NavItemType } from 'types';

const icons = {
    IconCalendarEvent
};

// ==============================|| MENU ITEMS - MARKETING ||============================== //

const marketing: NavItemType = {
    id: 'marketing',
    title: 'Marketing',
    type: 'group',
    children: [
        {
            id: 'calendar',
            title: 'Marketing Calendar',
            type: 'item',
            url: APPLICATION_ROUTES.ordering.marketingCalendar,
            icon: icons.IconCalendarEvent,
            breadcrumbs: false
        }
    ]
};

export default marketing;
